import { render, staticRenderFns } from "./APInfo.vue?vue&type=template&id=54ce3d0b&"
import script from "./APInfo.vue?vue&type=script&lang=js&"
export * from "./APInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports